import {useEffect,} from 'react';

import {useCustomerSubscriptions} from '../hooks/useCustomerSubscriptions.ts';
import {CustomerSubscription} from '../types';
import {FieldProps} from 'formik';
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {TextInputProps} from "@mantine/core";

export const SubscriptionsAutocomplete = (props: FieldProps & TextInputProps) => {

    const {
        items: records,
        loading,
        fetchRecords
    } = useCustomerSubscriptions();


    useEffect(() => {
        fetchRecords();
    }, [fetchRecords]);


    return (

        <FormikGenericCombobox
            records={(records as CustomerSubscription[]) || []}
            valueFieldName={'id'}
            renderOption={(record: CustomerSubscription) => `${record.id}`}
            getSelectedOption={(record: CustomerSubscription) => `${record.id}`}
            isLoading={loading}
            {...props}
        />

    );
};